module.exports = {
    url: "https://chatserver.phuongnamdigital.com/api"
}